module.exports = "/images/icon_reviewstar_blue.png?d993795c5a271701d1b676116cdcdc8d";